import { FAQTranslation } from "../../../assets/i18n/faq/FAQ";
import { HomeTranslation } from "../../../assets/i18n/home/Home";
import { MenuTranslation } from "../../../assets/i18n/menu/Menu";
import { TermsTranslation } from "../../../assets/i18n/terms/Terms";
export const locale = {
    lang: 'pt',
    data: {
        MENU: { ...MenuTranslation.pt },
        HOME: { ...HomeTranslation.pt },
        FAQ: {...FAQTranslation.pt},
        TERMS:{...TermsTranslation.pt}	
    }
};
